import React, { useEffect, useState ,useRef} from 'react'
import Header from '../components/Header'
import KnowPanditbanner from "../assets/KnowPandit/Banner.jpg";
import KnowPanditcardimg from "../assets/KnowPandit/Rectangle 63.jpg";
import KnowPanditrighticon from "../assets/KnowPandit/material-symbols_verified-rounded.jpg";
import "../components/styles/Pandit.css";
import pandits from "../assets/pandits.png"; // Replace with actual images
import pujaserved from "../assets/pujaserved.png";
import Pujatype from "../assets/Pujatype.png";
import '../../src/components/styles/Home.css';
import BookPurohits from "../assets/BookPurohits.png";
import Footer from '../components/Footer';
import '../../src/components/styles/Home.css';
import axios from 'axios';

import { toast, ToastContainer } from "react-toastify";
import BookPanditForm from "../components/BookPanditForm";

import { getPandits } from "../services/panditService";

import BookPanditPopupModal
from "../components/BookPanditPopupModal";

const Pandit = () => {

   const [isMobile, setIsMobile] = useState(false);



  const testimonials = [
    {
      id: 1,
      name: "“An amazing service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description: "Lorem ipsum dolor sit ametolil col consectetur adipiscing lectus a nunc mauris scelerisque sed egestas.",
      position: "CEO, Carryminati production house",
      quote: "Ajay Nagar",
    },
    {
      id: 2,
      name: "“One of a kind service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description: "Ultrices eros in cursus turpis massa tincidunt sem nulla pharetra diam sit amet nisl suscipit adipis.",
      position: "Developer, THYO India",
      quote: "Deepak Gupta",
    },
    {
      id: 3,
      name: "“The best service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description: "Convallis posuere morbi leo urna molestie at elementum eu facilisis sapien pellentesque habitant.",
      position: "CEO, Carryminati production house",
      quote: "Rajiv Ranjan",
    }

  ];




    const [panditllist, setPanditllist] = useState([]);
  const panditScrollRef = useRef(null);
  
  
  
  useEffect(() => {
  
    const selectedCityId =
      localStorage.getItem("selectedCityId") || "";
  
    getPandits(selectedCityId)
      .then((response) => {
  
        const panditList =
          response?.data?.data?.pandit_list || [];
  
        setPanditllist(panditList);
  
        console.log(
          "Pandit List:",
          panditList
        );
  
      })
      .catch((err) => {
  
        console.error(
          "Pandit API Error:",
          err
        );
  
      });
  
  }, []);
  
  
    
  return (

    <>
      <Header />
      <div className="Know_Your_Pandit mt-5">
        <div className="banner">
          <img src={KnowPanditbanner} alt="" className=" img-fluid w-100" />
        </div>

          <div className="container py-4 position-relative">
      <button
        className="btn priimary position-absolute start-0 top-50 translate-middle-y d-none d-md-block"
        onClick={() => panditScrollRef.current?.scrollBy({ left: -300, behavior: 'smooth' })}
        style={{
          zIndex: 10,
          backgroundColor: '#6B2A00',
          color: 'white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: 0
        }}
      >
        ❮
      </button>

      <div
        ref={panditScrollRef}
        className="d-flex overflow-auto"
        style={{
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          gap: "20px",
          paddingLeft: "10px",
          paddingRight: "10px"
        }}
      >
        {panditllist.map((pandit, index) => (
          <div 
            key={index} 
            className="card_container2"
            style={{
              flex: "0 0 calc(25% - 15px)",
              minWidth: "280px",
              maxWidth: "300px"
            }}
          >
            <img
              src={pandit.photo}
              alt={pandit.name}
              className="rounded mx-auto d-block"
              style={{ 
                height: '250px', 
                objectFit: 'cover', 
                width: '100%',
                borderRadius: '10px'
              }}
            />
            {/* <h3 className="ms-auto mt-3">Chat Now</h3> */}
            <div style={{ margin: "12px", textAlign: "justify" }}>
              <h1 style={{ fontSize: '18px', fontWeight: '600', color: '#6B2A00' }}>
                {pandit.name}
              </h1>
              <p style={{ fontSize: '13px', color: '#555', marginBottom: '10px' }}>
                {pandit.description.substring(0, 100)}...
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ fontSize: '16px', marginBottom: 0 }}>
                  ⭐ {pandit.experience} Yrs
                </h2>
                <p style={{ fontSize: '14px', color: '#E3952A', marginBottom: 0 }}>
                  ₹{pandit.dakshina}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn priimary position-absolute end-0 top-50 translate-middle-y d-none d-md-block"
        onClick={() => panditScrollRef.current?.scrollBy({ left: 300, behavior: 'smooth' })}
        style={{
          zIndex: 10,
          backgroundColor: '#6B2A00',
          color: 'white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: 0
        }}
      >
        ❯
      </button>
    </div>

    {panditllist.length === 0 && (
      <div className="text-center">
        <p>No pandits available for your city</p>
      </div>
    )}


      </div>



      <section
        className="position-relative text-white py-5 d-flex align-items-center mt-5"
        style={{
          backgroundImage: `url(${BookPurohits})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}>

        <div className="container p-3 p-sm-5">
          <div className="row align-items-center text-center text-sm-start">
            {/* Left Side: Heading & CTA Button */}
            <div className="col-12 col-md-4 mb-4 mb-md-0">
              <h2 className="display-6">Avail our services and benefit yourselves!</h2>
              <a
  className="botoun d-inline-block mt-2 text-decoration-none text-yellow fw-bold"
  style={{ color: "#E3952A", cursor: "pointer" }}  onClick={() => {
    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
>
  Book A Pandit Today!
</a>
            </div>
            {/* Right Side: Service Cards */}
            <div className="col-12 col-md-7 offset-md-1">
              <div className="row g-3">
                {[
                  { img: Pujatype, title: "251+ Puja Type", desc: "Choose from a wide range of over 251+ Puja types." },
                  { img: pandits, title: "150+ Pandits", desc: "With a team of 150+ expert Pandits." },
                  { img: pujaserved, title: "2100+ Puja Served", desc: "Over 2100+ pujas performed, each bringing divine blessings to our clients." }
                ].map((item, index) => (
                  <div key={index} className="col-12 col-sm-6 col-md-4">
                    <div className="p-3 border rounded text-center bg-opacity-20" style={{ height: '260px' }}>
                      <img
                        src={item.img}
                        alt={item.title}
                        className="img-fluid mx-auto mb-3"
                        style={{ objectFit: 'contain', maxHeight: "100px" }}
                      />
                      <h3 className="h5" style={{ fontSize: '18px' }}>{item.title}</h3>
                      <p className="small">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* <div className="container">
        <div className="row justify-content-center gap-4 mt-5 mb-5">
         
        {panditllist.map((pandit) => (
               
               <div className="col-lg-4 col-md-6 col-12 KnowPanditcardcontainer  " index={pandit.id}>
               <div className="d-flex align-items-center justify-content-center   ">
                 <img
                   src={pandit.pandit_img || KnowPanditcardimg} 
                   alt=""
                   className="KnowPanditcardcontainerimg1"
                 />
                 <div className="KnowPanditcard_h1_p1 mt-4 ms-4">
                   <h1>{pandit.name}</h1>
                   <p>{pandit.description}</p>
                   <p>Sanskrit, English, Hindi</p>
                   <p>8 yrs</p>
 
                   <div className="d-flex align-items-center justify-content-between flex-wrap">
                     <h1>
                       {" "}
                       <i class="fa-solid fa-indian-rupee-sign"></i>30/min
                     </h1>
                     <h2> <a href="#" style={{ textDecoration: 'none', color: 'black' }} target="_blank" rel="noopener noreferrer">Online</a></h2>
 
                   </div>
                 </div>
                 <img
                   src={KnowPanditrighticon}
                   className="KnowPanditcardcontainerimg2 mb-auto mt-2 ms-2"
                   alt=""
                 />
               </div>
               <hr />
               <div className="d-flex   KnowPanditcard_last_part align-items-center text-center justify-content-around flex-wrap">
                 <div>
                   <i class="fa-brands fa-rocketchat"></i>
                   <h1>60k mins</h1>
                 </div>
                 <div>
                   <i class="fa-solid fa-phone"></i>
                   <h1>30k mins</h1>
                 </div>
                 <div className="d-flex KnowPanditcard_last_part2 text-center align-items-center   justify-content-evenly flex-wrap">
                   <i class="fa-solid fa-video"></i>
                   <h1> <a href="#" style={{ textDecoration: 'none', color: 'black' }} target="_blank" rel="noopener noreferrer">watch Intro</a></h1>
                 </div>
               </div>
             </div>
              ))}
        </div>
      </div> */}




      <section className="py-5 bg-light">
        <div className="container">
          {/* Section Header */}
          <div className="text-center mb-4">
            <span className="text-uppercase testinaction">Testimonials</span>
            <h2 className="fboldtext">What our clients say</h2>
          </div>

          {/* Bootstrap Grid - 2 Rows, 3 Columns Each */}
          <div className="row g-4">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="col-md-4 ">
                <div className="card border-1 shadow-sm p-5 rounded-4">
                  <div className="">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="rounded-circle me-3"
                      width="60"
                      height="60"
                      style={{ objectFit: "cover", border: '1px solid black' }}
                    />
                    <h5 className="textiname mb-3 mt-3">{testimonial.name}</h5>
                    <p className="psmaltext small mb-2">{testimonial.description}</p>
                  </div>

                  <blockquote className="mt-3 textinaeme">
                    {testimonial.quote}
                  </blockquote>
                  <p className="psmaltext small mb-0">{testimonial.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
       <div className={isMobile ? "bg-white" : "Container_img img-fluid"}>
    
    
            <BookPanditForm />
            <ToastContainer />
    
            </div>
      <Footer />
          <BookPanditPopupModal />
    </>

  )
}

export default Pandit